/////////////////////////////////////////////////////////////////////////////////////////////
// Copyright 2026 Garmin International, Inc.
// Licensed under the Flexible and Interoperable Data Transfer (FIT) Protocol License; you
// may not use this file except in compliance with the Flexible and Interoperable Data
// Transfer (FIT) Protocol License.
/////////////////////////////////////////////////////////////////////////////////////////////
// ****WARNING****  This file is auto-generated!  Do NOT edit this file.
// Profile Version = 21.218.0Release
// Tag = production/release/21.218.0-0-g96fee6d7
/////////////////////////////////////////////////////////////////////////////////////////////

package com.garmin.fit

import com.garmin.fit.types.*
import kotlin.time.Instant

/**
 * The FIT `exd_data_concept_configuration` message.
 *
 * A thin typed view over [Mesg]: the accessors below read and write the same
 * numbered fields the untyped API exposes, so nothing is hidden by using them.
 */
public open class ExdDataConceptConfigurationMesg : Mesg {
    public constructor() : super("ExdDataConceptConfiguration", Profile.MesgNum.EXD_DATA_CONCEPT_CONFIGURATION)

    public constructor(mesg: Mesg) : super(mesg)

    internal constructor(mesg: Mesg, adopt: Boolean) : super(mesg, adopt)

    /** screen_index. */
    public var screenIndex: UByte?
        get() = getFieldValue(SCREEN_INDEX_FIELD_NUM) as? UByte
        set(value) = setFieldValue(SCREEN_INDEX_FIELD_NUM, value)

    /** concept_field. */
    public var conceptField: UByte?
        get() = getFieldValue(CONCEPT_FIELD_FIELD_NUM) as? UByte
        set(value) = setFieldValue(CONCEPT_FIELD_FIELD_NUM, value)

    /** field_id. */
    public var fieldId: UByte?
        get() = getFieldValue(FIELD_ID_FIELD_NUM) as? UByte
        set(value) = setFieldValue(FIELD_ID_FIELD_NUM, value)

    /** concept_index. */
    public var conceptIndex: UByte?
        get() = getFieldValue(CONCEPT_INDEX_FIELD_NUM) as? UByte
        set(value) = setFieldValue(CONCEPT_INDEX_FIELD_NUM, value)

    /** data_page. */
    public var dataPage: UByte?
        get() = getFieldValue(DATA_PAGE_FIELD_NUM) as? UByte
        set(value) = setFieldValue(DATA_PAGE_FIELD_NUM, value)

    /** concept_key. */
    public var conceptKey: UByte?
        get() = getFieldValue(CONCEPT_KEY_FIELD_NUM) as? UByte
        set(value) = setFieldValue(CONCEPT_KEY_FIELD_NUM, value)

    /** scaling. */
    public var scaling: UByte?
        get() = getFieldValue(SCALING_FIELD_NUM) as? UByte
        set(value) = setFieldValue(SCALING_FIELD_NUM, value)

    /** data_units. */
    public var dataUnits: ExdDataUnits?
        get() = (getFieldValue(DATA_UNITS_FIELD_NUM) as? UByte)?.let { ExdDataUnits.fromValue(it) }
        set(value) = setFieldValue(DATA_UNITS_FIELD_NUM, value?.value)

    /** qualifier. */
    public var qualifier: ExdQualifiers?
        get() = (getFieldValue(QUALIFIER_FIELD_NUM) as? UByte)?.let { ExdQualifiers.fromValue(it) }
        set(value) = setFieldValue(QUALIFIER_FIELD_NUM, value?.value)

    /** descriptor. */
    public var descriptor: ExdDescriptors?
        get() = (getFieldValue(DESCRIPTOR_FIELD_NUM) as? UByte)?.let { ExdDescriptors.fromValue(it) }
        set(value) = setFieldValue(DESCRIPTOR_FIELD_NUM, value?.value)

    /** is_signed. */
    public var isSigned: Boolean?
        get() = (getFieldValue(IS_SIGNED_FIELD_NUM) as? UByte)?.let { it.toInt() != 0 }
        set(value) = setFieldValue(IS_SIGNED_FIELD_NUM, value?.let { if (it) 1 else 0 })

    public companion object {
        public const val SCREEN_INDEX_FIELD_NUM: UByte = 0u
        public const val CONCEPT_FIELD_FIELD_NUM: UByte = 1u
        public const val FIELD_ID_FIELD_NUM: UByte = 2u
        public const val CONCEPT_INDEX_FIELD_NUM: UByte = 3u
        public const val DATA_PAGE_FIELD_NUM: UByte = 4u
        public const val CONCEPT_KEY_FIELD_NUM: UByte = 5u
        public const val SCALING_FIELD_NUM: UByte = 6u
        public const val DATA_UNITS_FIELD_NUM: UByte = 8u
        public const val QUALIFIER_FIELD_NUM: UByte = 9u
        public const val DESCRIPTOR_FIELD_NUM: UByte = 10u
        public const val IS_SIGNED_FIELD_NUM: UByte = 11u

        /**
         * The profile definition of every field of this message, with no values.
         *
         * Built once when this class is first touched, and handed out only as
         * copies, so the decoder pays for a message type it never meets nothing.
         */
        internal val PROTOTYPE_FIELDS: Map<Int, Field> = buildPrototypeFields()

        private fun buildPrototypeFields(): Map<Int, Field> {
            val fields = LinkedHashMap<Int, Field>()
            fields[0] = Field("ScreenIndex", 0u, BaseType.UINT8, 1.0, 0.0, "", false)
            fields[1] = Field("ConceptField", 1u, BaseType.BYTE, 1.0, 0.0, "", false)
                .addComponent(FieldComponent(2u, false, 4, 1.0, 0.0))
                .addComponent(FieldComponent(3u, false, 4, 1.0, 0.0))
            fields[2] = Field("FieldId", 2u, BaseType.UINT8, 1.0, 0.0, "", false)
            fields[3] = Field("ConceptIndex", 3u, BaseType.UINT8, 1.0, 0.0, "", false)
            fields[4] = Field("DataPage", 4u, BaseType.UINT8, 1.0, 0.0, "", false)
            fields[5] = Field("ConceptKey", 5u, BaseType.UINT8, 1.0, 0.0, "", false)
            fields[6] = Field("Scaling", 6u, BaseType.UINT8, 1.0, 0.0, "", false)
            fields[8] = Field("DataUnits", 8u, BaseType.ENUM, 1.0, 0.0, "", false)
            fields[9] = Field("Qualifier", 9u, BaseType.ENUM, 1.0, 0.0, "", false)
            fields[10] = Field("Descriptor", 10u, BaseType.ENUM, 1.0, 0.0, "", false)
            fields[11] = Field("IsSigned", 11u, BaseType.ENUM, 1.0, 0.0, "", false)
            return fields
        }
    }
}
